import { getUserRoles } from '../selectors/map.selector';

// eslint-disable-next-line import/prefer-default-export -- @refactor later
export function isAdmin(state) {
  return getUserRoles(state).includes('ROLE_ADMIN');
}
